import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { postCoreDataSecurityAccessComparisonExportSlice } from './post';

export const coreDataSecurityAccessComparisonExportReducers = combineReducers({
	post: postCoreDataSecurityAccessComparisonExportSlice.asyncReducers
});

export const coreDataSecurityAccessComparisonExportWatchers = combineAllWatchers([
	postCoreDataSecurityAccessComparisonExportSlice.asyncWatchers
]);
